module.exports = __webpack_public_path__ + "img/6H.ee931de8.png";